import { render, staticRenderFns } from "./CaseGraphDetailHeader.vue?vue&type=template&id=820db46c&scoped=true"
import script from "./CaseGraphDetailHeader.vue?vue&type=script&lang=ts"
export * from "./CaseGraphDetailHeader.vue?vue&type=script&lang=ts"
import style0 from "./CaseGraphDetailHeader.vue?vue&type=style&index=0&id=820db46c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820db46c",
  null
  
)

export default component.exports